export const CHAT_TITLE_MAX_LENGTH = 255;
export const MAX_QUESTION_CHARS = 8000;
export const NEW_ROW_ANIMATION_MS = 300;
export const MS_PER_MINUTE = 60 * 1000;
export const MS_PER_HOUR = 60 * MS_PER_MINUTE;
export const MS_PER_DAY = 24 * MS_PER_HOUR;
export const CREDIT_BALANCE_GRID_PAGE_SIZE = 500;
export const CREDIT_CONSUMPTION_GRID_PAGE_SIZE = 50;
export const RECENT_CONSUMPTION_LIMIT = 5;
